const unloadGuards = new Set<() => void>();

/** Register an editor's unload warning so an accepted switch can bypass a second prompt. */
export function registerProjectSwitchGuard(allowUnload: () => void): () => void {
  unloadGuards.add(allowUnload);
  return () => {
    unloadGuards.delete(allowUnload);
  };
}

/** Ask before changing the URL or persisted project selection. */
export function confirmProjectSwitch(): boolean {
  if (unloadGuards.size === 0) return true;
  if (!window.confirm('Discard unsaved changes and switch projects?')) return false;
  for (const allowUnload of unloadGuards) allowUnload();
  return true;
}
